import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { of as observableOf} from 'rxjs/observable/of';
import {debounceTime, distinctUntilChanged, startWith, tap, delay} from 'rxjs/operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {merge} from 'rxjs/observable/merge';
import {fromEvent} from 'rxjs/observable/fromEvent';

import { TrackerService } from '../../../_services/trackers.service';
import { TrackerDataSource } from './trackers.datasource';
import { IMultiSelectTrackerRow } from '../../../_models/tracker';
import { PaginationParams } from '../../../_models/generic';


@Component({
  selector: 'app-dl-multi-select-trackers',
  templateUrl: './dl-multi-select-trackers.component.html',
  styleUrls: ['./dl-multi-select-trackers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlMultiSelectTrackersComponent implements OnInit {

  //selected: Array<IMultiSelectTrackerRow> = [];

  dataSource: TrackerDataSource;
  displayedColumns: string[] = ['tracker', 'id'];
  public defaultPageSize: number = 25;
  public pageDisplayOptions: Array<number> = [25, 50, 75, 100];

  @Input() selected: Array<IMultiSelectTrackerRow>;
  @Input() labelText: string;
  @Output() outputSelectedVehicles = new EventEmitter<Array<IMultiSelectTrackerRow>>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('multiSelectSearch') tableSearchInput: ElementRef;

  constructor(private trackerService: TrackerService) {
  }

  ngOnInit() {
    if (this.selected === undefined) {
      this.selected = [];
    }

    // Create new instance of datasource
    this.dataSource = new TrackerDataSource(this.trackerService);
    // Get first page of data
    this.loadInitialVehicles();
  }

  ngAfterViewInit() {
    // server-side search
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
        .pipe(
            debounceTime(150),
            distinctUntilChanged(),
            tap(() => {
                this.paginator.pageIndex = 0;
                this.loadVehiclePage();
            })
        )
        .subscribe();

    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // on sort or paginate events, load a new page
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadVehiclePage())
    )
    .subscribe();
  }

  public selectTrackerItem(item: IMultiSelectTrackerRow) {
    if ( this.isRowSelected(item.id) ) {
      return false;
    } else {
      this.selected.push(item);
      this.outputSelectedVehicles.emit(this.selected);
    }
  }

  public deSelectItem(index: number, item: IMultiSelectTrackerRow) {
    this.selected.splice(index, 1);
    this.outputSelectedVehicles.emit(this.selected);
  }
  public clearAllSelected() {
    this.selected = [];
    this.outputSelectedVehicles.emit(this.selected);
  }

  public isRowSelected(id: number) {
    if (this.selected !== undefined) {
      const _found = this.selected.some(function (el) {
        return el.id === id;
      });
      if (_found) {
        return true;
      }
    }
    return false;
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
    this.loadVehiclePage();
  }

  private loadInitialVehicles() {
    const _params: PaginationParams = {
      pageSize: 50,
      page: 1,
      orderingDirection: '',
      ordering: 'tracker',
      search: ''
    };
    this.dataSource.loadAdminVehicles(_params);
  }

  private loadVehiclePage() {
    const _params: PaginationParams = {
      pageSize: this.paginator.pageSize,
      page: this.paginator.pageIndex + 1,
      orderingDirection: this.sort.direction,
      ordering:  this.sort.active,
      search: this.tableSearchInput.nativeElement.value
    };
    this.dataSource.loadAdminVehicles(_params);
  }


}






// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-trackers/dl-multi-select-trackers.component.ts